import React from 'react';
import { Container, Row, Col, ListGroup, Image, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import nurani from "../assets/nurani.webp";
import basic from "../assets/basic-reading.webp";
import memorizing from "../assets/memorizing.webp";
import salat from "../assets/salat.webp";

// Courses data with images
const courses = [
  {
    id: "noorani-qaida",
    title: "Noorani Qaida",
    desc: "Noorani Qaida is the first step in the journey of analyzing the Holy Quran. Noorani Qaida contains almost all the pronunciation rules of reciting the Holy Quran.",
    learn: [
      "You will learn recognition of Arabic letters in different shapes and sounds.",
      "You will learn Makharij of the Arabic Alphabets.",
      "You will learn basic rules of tajweed.",
      "You will learn how to read Quran with proper pronunciation.",
    ],
    img: nurani,
  },
  {
    id: "basic-quran-reading",
    title: "Basic Quran Reading",
    desc: "This course is designed for students who can read Quran but are not fluent in reading Quran and want to improve their reading skills.",
    learn: [
      "You will learn Method of reading Holy Quran with proper Makharij",
      "You will learn Definitions of Hadar and Tarteel",
      "You will learn Obligatory knowledge and teachings of Islam",
    ],
    img: basic,
  },
  {
    id: "quran-memorization",
    title: "Quran Memorization",
    desc: "You will actually memorize complete Quran with correct pronunciation in Arabic accent.",
    learn: [
      "You will learn to read the Arabic language using Noorani Qaida curriculum.",
      "You will be given new lesson for memorization daily.",
      "Evaluation of the lesson given in the last week.",
      "Consolidation of all old lessons.",
    ],
    img: memorizing,
  },
  {
    id: "salah-kalmas-duas",
    title: "Salah / Kalmas / Duas",
    desc: "We offer online Salah/Dua classes beside Quran Reading for our Muslim brothers and sisters who want to learn Salah & Hadith properly.",
    learn: [
      "You will learn Faraiz of Namaz (Salah’s obligations)",
      "You will learn Preconditions of Namaz & its Mufsidaat (The actions which break Salah)",
      "You will learn Makroohat-e-Namaz (The actions get Salah revised).",
      "You will learn How to offer Funeral Salah, Passenger’s Salah, Eid Salah and missed Salah (Qadha Namaz).",
    ],
    img: salat,
  },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const courseIds = courses.map((c) => ({ id: c.id, title: c.title }));

const CourseSection = ({ course, reverse }) => {

  return (
    <section
      id={course.id} // <-- scroll target
      style={{
        padding: "80px 0",
        backgroundColor: reverse ? "#f9f9f9" : "#fff",
        scrollMarginTop: "70px", // offset for fixed navbar height
      }}
    >
      <Container>
        <Row className="align-items-center">
          <Col
            lg={6}
            className={reverse ? "order-lg-2 mb-4 mb-lg-0" : "mb-4 mb-lg-0"}
          >
            <div style={{ overflow: "hidden" }}>
              <motion.div
                initial={{ x: -200, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 1.2, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Image
                  src={course.img}
                  alt={course.title}
                  fluid
                  rounded
                  style={{
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    width: "95%",
                  }}
                />
              </motion.div>
            </div>
          </Col>

          <Col lg={6} className={reverse ? "order-lg-1" : ""}>
            <div style={{ overflow: "hidden" }}>
              <motion.div
                initial={{ x: 200, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h2 style={titleStyle}>{course.title}</h2>
                <p style={descStyle}>{course.desc}</p>
                <h4 style={subTitleStyle}>What Will You Learn?</h4>
                <ListGroup variant="flush" className="mb-3">
                  {course.learn.map((item, idx) => (
                    <ListGroup.Item key={idx} style={listItemStyle}>
                      {item}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo("home");
                  }}
                  style={{ backgroundColor: "#0D3B66", border: "none" }}
                >
                  Get Free Trial
                </Button>
              </motion.div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const Courses = () => {
  return (
    <div id="courses">
      <h2 style={toPtitleStyle} className="text-center mb-2 mt-5">
        Our Courses
      </h2>
      {courses.map((course, idx) => (
        <CourseSection key={idx} course={course} reverse={idx % 2 !== 0} />
      ))}
    </div>
  );
};

// Styles
const titleStyle = {
  fontSize: "2rem",
  fontWeight: "700",
  marginBottom: "1rem",
  color: "#0d3b66",
};

const toPtitleStyle = {
  color: "#0d3b66",
  fontWeight: "700",
};

const descStyle = {
  fontSize: "1.05rem",
  lineHeight: "1.6",
  color: "#333",
  marginBottom: "1.2rem",
};

const subTitleStyle = {
  fontSize: "1.25rem",
  fontWeight: "600",
  marginBottom: "1rem",
  color: "#1d4e89",
};

const listItemStyle = {
  fontSize: "1rem",
  padding: "0.5rem 1rem",
  border: "none",
  color: "#555",
};

export default Courses;
